import { Injectable } from "@angular/core";
import { AuthenticationService } from "./authentication.service";
import { CredentialService } from "./credential.service";
import { Store } from "@ngrx/store";
import { Observable } from "rxjs/Observable";
import { environment } from "environments/environment";
import { inflate } from "zlib";
import { allRoleFields } from "ngrx/graphql";
import { Role } from "app/models/role.model";

const errorCodes = [400, 401, 403, 404];

@Injectable()
export class RoleService {
  constructor(
    private authService: AuthenticationService,
    private credentialService: CredentialService,
    private store: Store<any>
  ) {}

  private invokeRoles(payload: any): Observable<any> {
    return new Observable(observer => {

      this.credentialService.lambda.invoke({
        FunctionName: environment.batchFunction,
        Payload: JSON.stringify(payload)
        }, (err, data) => {
          if (err) {
            if (errorCodes.find(code => code === err.statusCode) && localStorage.getItem('currentUser')) {
              this.authService.refreshCredentials();
            } 
            observer.error(err.stack);
          } else {
            const output = typeof data.Payload === 'string'
                ? JSON.parse(data.Payload)
                :       data.Payload;
            if(output.gzip){
              const options = {
                windowBits : 15
              };
              inflate(new Buffer(output.body,'base64'), options, (err, data) => {
                if (err) {                    
                  observer.error(err.stack);
                } else {
                  const unzippedOutput = Object.assign({}, output, {
                    body: data.toString()
                  });
                  observer.next(unzippedOutput);
                }
              });
            } else {
              observer.next(output);
            }
          }
        }
      )
    });
  }

  private invokeRolesMutation(payload: any): void {
    this.credentialService.lambda.invoke({
      FunctionName: environment.batchFunction,
      Payload: JSON.stringify(payload)
      }, (err, data) => {
        if (err) {
          if (errorCodes.find(code => code === err.statusCode) && localStorage.getItem('currentUser')) {
            this.authService.refreshCredentials();
          }
        }
      }
    );
  }

  getAll(): Observable<any> {
    const query = `{
      roles(param: "all") {
        ${allRoleFields}
      }

    }`;

    return this.invokeRoles({ query });
  }

  getRole(id: string): Observable<any> {
    const query = `{
      role(id: "${id}") {
        ${allRoleFields}
      }
    }`;

    return this.invokeRoles({ query });
  }

  getRoleList(): Observable<Role[]> {
    return this.store.select('roles', 'roleList');
  }

  updateRole(role: any): void {
    const variables = { role };
    const query = `mutation ($role: RoleInput!) {
      updateRole(role: $role) {
        ${allRoleFields}
      }
    }`;

    this.invokeRolesMutation({ query, variables });
  }

}


// WEBPACK FOOTER //
// /Users/itu/Desktop/impreso_updated_sheets/impresocloud/www/client/src/app/services/role.service.ts